import {vettingResults, VettingResults} from "./vetting-results/VettingResultsComponent";
import {equityOrderDisplay, EquityOrderDisplay} from "./equity-display/EquityOrderDisplayComponent";
import {equityOrderSummary, EquityOrderSummary} from "./equity-order-summary/EquityOrderSummaryComponent";
import {
    multiAccountEquityOrderDisplay,
    MultiAccountEquityOrderDisplay
} from "./multi-account-equity-display/MultiAccountEquityOrderDisplayComponent";
import {
    multiAccountEquityOrderSummary,
    MultiAccountEquityOrderSummary
} from "./multi-account-equity-order-summary/MultiAccountEquityOrderSummaryComponent";
import {
    multiAccountVettingResults,
    MultiAccountVettingResults
} from "./multi-account-vetting-results/MultiAccountVettingResultsComponent";

export default function(parentModule: string): string {
    const moduleName = `${parentModule}.components`;
    return angular.module(moduleName, [])
                  .component(EquityOrderDisplay, equityOrderDisplay())
                  .component(EquityOrderSummary, equityOrderSummary())
                  .component(VettingResults, vettingResults())
                  .component(MultiAccountEquityOrderDisplay, multiAccountEquityOrderDisplay())
                  .component(MultiAccountEquityOrderSummary, multiAccountEquityOrderSummary())
                  .component(MultiAccountVettingResults, multiAccountVettingResults())
                  .name;
}
